<template>
    <div class="content-container">
        <div class="content h-auto">
            <div class="container">
                <div class="row">

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>{{ pageTitle }}</h1>
                        </div>
                    </div>

                    <div class="col-12">
                        <!-- Basket Items -->
                        <template v-if="hasDevices">
                            <div v-for="(device, key) in devices" :key="key">
                                <basket-item :device-data="device" :device-key="key" showCard></basket-item>
                            </div>
                        </template>

                        <!-- Empty basket -->
                        <div class="card card-body py-5 text-center" v-if="!hasDevices">
                            <icon-shopping-cart class="icon-all-text-colour icon-chunky mb-2 mx-auto" size="lg"></icon-shopping-cart>
                            <strong>There are no items in your basket</strong>
                        </div>

                        <!-- Add link -->
                        <div @click="addDeviceLink" v-if="canAddNewDevice || devicesInCart === 0" class="card card-body flex-row align-items-center cursor-pointer justify-content-center text-decoration-none">
                            <i class="fa fa-plus mr-3"></i> <strong>Add a<template v-if="hasDevices">nother</template> device</strong>
                        </div>
                        <table v-if="!this.inWarrantyStatus" class="price-table grand-total">
                            <tr class="total-cost">
                                <td class="border-t-0">Total:</td>
                                <td class="border-t-0"><span v-html='currencySymbol'></span>{{ cartTotal }}</td>
                            </tr>
                        </table>
                    </div>
                    <!-- Footer -->
                    <footer class="footer">
                        <div class="container">
                            <router-link :to="{ name: nextStep}" class="btn btn-primary btn-lg continue-btn icon-right ml-auto" :disabled="!hasDevices">Next <i class="fa fa-chevron-right ml-3 text-sm"></i></router-link>
                        </div>
                    </footer>
                </div>

                <!-- "An in-warranty device exists in basket" modal -->
                <in-warranty-device-exists-modal></in-warranty-device-exists-modal>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "Basket",

        mounted() {
            this.checkBookingIsComplete().then(() => {
                if (!this.selectedProblems.length) {
                    return this.$router.push({name: 'repairSelect'})
                }

                this.checkDeviceWarrantyDetails();

                this.retrieveBooking();

                if (!this.hasAvailability) {
                    this.loadAvailability({ startDate: null, daysToLoad: 6 })
                }
            });
        },

        computed: {
            ...mapGetters([
                'allowsMultiDeviceBooking',
                'allowsStoreDropOff',
                'booking',
                'carrierDetails',
                'devices',
                'devicesInCart',
                'hasAvailability',
                'hasDevices',
                'inWarrantyStatus',
                'selectedProblems',
                'store',
                'isBookingInStore',
                'cartTotal',
                'currencySymbol',
                'onlyOfferSamsung'
            ]),

            nextStep() {
                if (this.allowsStoreDropOff && this.isBookingInStore) {
                // if (this.allowsStoreDropOff) {
                    return 'repairOptions';
                }
                return 'repairDates';
            },

            canAddNewDevice() {
                if (this.inWarrantyStatus) return false;
                return this.allowsMultiDeviceBooking;
            },

            pageTitle() {
                if (this.isBookingInStore) {
                    return "Basket";
                }

                return "Your basket";
            }
        },

        methods: {
            ...mapActions([
                'checkBookingIsComplete',
                'checkDeviceWarrantyDetails',
                'clearDevice',
                'loadAvailability',
                'loadTypes',
                'retrieveBooking',
                'selectMake'
            ]),

            addDeviceLink() {
                if (this.inWarrantyStatus && this.devicesInCart) {
                    return this.$bvModal.show("in-warranty-device-exists-modal");
                }

                if (!this.canAddNewDevice) return null;

                this.clearDevice().then(() => {
                    if (this.onlyOfferSamsung) {
                        this.selectMake({
                            id: 2
                        }).then(() => {
                            this.loadTypes();
                            this.$router.push({name: 'deviceType'});
                        })
                        return
                    }

                    return this.$router.push({name: 'deviceMake'})
                });
            }
        }
    }
</script>